<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制"
    width="80%"
    @confirm="confirm"
    @close="(selectData = []), (currency = {cropNum: '',is_title: '0',is_notice: '0',is_repeat_submit: '0'}),$emit('guanbi')"
  >
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="mpAdvertiserListParams.account_id"
            placeholder="请输入广告账户id"
            rows="8"
          >
            <!-- @input="($event)=>{
              mpAdvertiserListParams.job_id = handleParams($event)
            }" -->
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="searchMpAdvert"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="resetMpAdvertList"
        >重置</el-button>
        <el-button
          type="primary"
          @click="clearSelect"
        >清空选项</el-button>
      </el-row>
    </div>

    <div class="center-container">
      <div class="center-left">
        <el-table
          v-if="mpAdvertiserList"
          ref="multipleTable"
          v-loading="isLoading"
          :data="mpAdvertiserList"
          :row-key="getRowKeys"
          border
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          />
          <el-table-column
            prop="account_id"
            label="广告主id"
          />
          <el-table-column
            prop="advertiser_name"
            label="广告主名称"
            width="270"
          >
            <template scope="scope">
              <p class="overflow" :title="scope.row.advertiser_name">{{ scope.row.advertiser_name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="复制的量">
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].num"
                class="input"
                type="number"
                min="1"
                max="50"
                placeholder="复制的量"
                @input="judge(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].remark"
                placeholder="请输入备注"
                @input="($event)=>{
                  selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].remark = handleParams($event)
                }"
              />
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="广告状态"
          >
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].operation"
                placeholder="请选择"
              >
                <el-option
                  label="开启"
                  :value="'ENABLE'"
                />
                <el-option
                  label="关闭"
                  :value="'DISABLE'"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间"
            width="150"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].begin_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                :picker-options="pickerOptions"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="结束时间"
            width="150"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].end_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                :picker-options="pickerOptions"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="agent_name"
            label="组织"
            width="200"
          >
            <template scope="scope">
              <p class="overflow" :title="scope.row.agent_name">{{ scope.row.agent_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="company"
            label="公司"
            width="200"
          >
            <template scope="scope">
              <p class="overflow" :title="scope.row.company">{{ scope.row.company }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        v-if="Object.keys(selectData).length !== 0"
        style="display: flex; flex-direction: column; justify-content: space-between;
               overflow: hidden;"
      >
        <div
          class="center-right"
          style="max-height:430px"
        >
          <h3>已选：</h3>
          <table border="1">
            <thead>
              <tr>
                <!-- <td class="fowwr">ID</td> -->
                <td style="width:90px">目标广告账户</td>
                <td style="width:80px">目标广告账户名称</td>
                <!-- <td style="width:80px">广告组名称</td> -->
                <!-- <td style="width:70px">状态</td> -->
                <td style="width:70px">复制的量</td>
                <td style="width:70px">广告状态</td>
                <!-- <td style="width:80px">落地页处理类型</td> -->
                <td style="width:70px">备注</td>
                <td style="width:70px">投放开始日期</td>
                <td style="width:70px">投放结束日期</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in selectData"
                :key="item.id"
              >
                <!-- <td>{{ item.id }}</td> -->
                <td>{{ item.account_id }}</td>
                <td>{{ item.advertiser_name }}</td>
                <!-- <td>{{ item.adgroup_id }}</td> -->
                <!-- <td> {{ item.account_status_text }} -->
                <!-- </td> -->
                <td>{{ item.num }}</td>
                <td>{{ item.operation==='ENABLE'? '开启': '关闭' }}</td>
                <!-- <td>{{ item.pages_handle==1?'授权': item.pages_handle==2?'创建':'' }}</td> -->
                <td>{{ item.remark }}</td>
                <td>{{ item.begin_time }}</td>
                <td>{{ item.end_time }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="center-right">
          <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>
          <table border="1">
            <thead>
              <tr>
                <td style="width:70px">复制的量</td>
                <td style="width:70px">备注</td>
                <td style="width:70px">广告状态</td>
                <!-- <td style="width:80px">原生页处理</td> -->
                <td style="width:70px">投放开始日期</td>
                <td style="width:70px">投放结束日期</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <el-input
                    v-model="currency.cropNum"
                    placeholder="请输入复制的量"
                    @input="currency.cropNum = $event.replace(/[^\d]/g, ''),handleCurrencyCropNum()"
                  />
                </td>
                <td>
                  <el-input
                    v-model="currency.remark"
                    placeholder="请输入备注"
                    @input="currency.remark = handleParams($event), selectData.forEach(item => item.remark = currency.remark)"
                  />
                </td>
                <td>
                  <el-select
                    v-model="currency.operation"
                    placeholder="请选择"
                    @change="selectData.forEach(item => item.operation = currency.operation)"
                  >
                    <el-option
                      label="开启"
                      :value="'ENABLE'"
                    />
                    <el-option
                      label="关闭"
                      :value="'DISABLE'"
                    />
                  </el-select>
                </td>
                <td>
                  <el-date-picker
                    v-model="currency.begin_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    placeholder="选择开始日期"
                    @change="handleCurrencyCropBegin_time()"
                  />
                </td>
                <td>
                  <el-date-picker
                    v-model="currency.end_time"
                    type="date"
                    :disabled="!currency.begin_time"
                    :picker-options="pickerOptions"
                    placeholder="选择结束日期"
                    value-format="yyyy-MM-dd"
                    @change="handleCurrencyCropEnd_time()"
                  />
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </div>

    <PaginationRight
      style="float: left;"
      :total="total"
      :page.sync="mpAdvertiserListParams.page"
      :limit.sync="mpAdvertiserListParams.page_size"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </GlobalWindow>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import { getAccountList } from '@/api/massiveAdvertising/accountList.js'

export default {
  name: 'CopyMpAdDialog',
  components: {
    GlobalWindow,
    PaginationRight
  },
  props: {
    // campaign_ids: {}
  },
  data() {
    return {
      isVisibled: false,
      isLoading: false,
      total: 0,
      mpAdvertiserListParams: {
        account_id: null,
        account_name: null,
        type: null,
        account_status: null,
        page: 1, // 当前页码
        // pageSize: null // 显示数据条数
        // page: 1, // 当前页码
        page_size: 10 // 显示数据条数
      },
      selectData: [],
      mpAdvertiserList: null,
      copyMpAdvertParams: {
        account_ids: [],
        account_id: null,
        adgroup_id: null,
        campaign_id: null,
        campaign_type: null
      },
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ],
      options1: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      optionsCrop: [
        {
          value: '0',
          label: '不裁剪'
        },
        {
          value: '1',
          label: '裁剪'
        },
        {
          value: '2',
          label: '四宫格'
        },
        {
          value: '3',
          label: '模糊化'
        }
      ],
      currency: {
        // 控制修改通用的
        cropNum: '',
        is_title: '0',
        is_notice: '0',
        is_repeat_submit: '0'
      },
      adgroup_items: [],
      pickerOptions: {
        disabledDate(date) {
          const today = new Date()
          today.setDate(today.getDate() - 1) // 获取昨天的日期

          return date <= today
        }
      },
      rowData: {},
      type: null
    }
  },
  created() {
    window.This = this
  },
  methods: {
    fetchPageSize(e) {
      this.mpAdvertiserListParams.page_size = e
      this.fetchMpAdvertiserList()
    },
    fetchCurrentPage(e) {
      this.mpAdvertiserListParams.page = e
      this.fetchMpAdvertiserList()
    },
    getRowKeys(row) {
      return row.id // 每条数据的唯一识别值
    },

    open(rowData, type) {
      console.log('rowData, type:', rowData, type)
      this.type = type
      if (type === 'batch') {
        this.adgroup_items = rowData
      } else {
        this.rowData = rowData
      }
      this.fetchMpAdvertiserList()
      this.isVisibled = true
    },

    // 获取广告主列表
    fetchMpAdvertiserList() {
      this.isLoading = true
      getAccountList({
        keyword: this.mpAdvertiserListParams.account_id,
        account_name: this.mpAdvertiserListParams.account_name,
        type: this.mpAdvertiserListParams.type,
        account_status: this.mpAdvertiserListParams.account_status,
        page: this.mpAdvertiserListParams.page,
        page_size: this.mpAdvertiserListParams.page_size
      }).then(res => {
        this.mpAdvertiserList = res.data.list
        // const duplicateData = JSON.parse(JSON.stringify(res.data.list[0]))
        // res.data.list[0].id = 5
        // this.mpAdvertiserList = [res.data.list[0], duplicateData]
        this.total = res.data.total
        this.isLoading = false
      })
    },
    clearSelect() {
      this.$refs.multipleTable.clearSelection()
    },

    // 初始化列表数据
    handleSelectionChange(data) {
      const res = []
      const datas = []
      data.forEach(item => {
        res.push(item.account_id)
        const s4 = this.selectData.filter(it => {
          return it.id === item.id
        })
        console.log('s4:', s4)
        datas.push({
          ...item,
          num: s4.length ? s4[0].num : 1, // 复制的量
          remark: s4.length ? s4[0].remark : null, // 备注
          // pages_handle: s4.length ? s4[0].pages_handle : null, // 原生页
          tianshu: s4.length ? s4[0].num : 1, // 复制的量
          operation: s4.length ? s4[0].operation : 'ENABLE', // 复制的量
          jiange: s4.length ? s4[0].jiange : 0, // 截止天数
          is_title: s4.length ? s4[0].is_title : '0', // 是否修改标题
          is_notice: s4.length ? s4[0].is_notice : '0', // 是否通知
          is_repeat_submit: s4.length ? s4[0].is_repeat_submit : '0', // 是否重复提交
          begin_time: s4.length ? s4[0].begin_time : this.formatDate(new Date()),
          end_time: s4.length ? s4[0].begin_time : this.formatDate(new Date().setFullYear(new Date().getFullYear() + 1))
        })
      })
      this.selectData = datas
      this.copyMpAdvertParams.account_ids = res
    },
    formatDate(date) {
      const currentDate = new Date(date)
      currentDate.setDate(currentDate.getDate())

      const year = String(currentDate.getFullYear()).slice() // 获取年份的后两位
      const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 获取月份（注意加1，因为月份从0开始）
      const day = String(currentDate.getDate()).padStart(2, '0') // 获取日期

      return `${year}-${month}-${day}`
    },
    searchMpAdvert() {
      // this.mpAdvertiserListParams.page = 1
      this.fetchMpAdvertiserList()
    },
    resetMpAdvertList() {
      this.mpAdvertiserListParams = {
        name: null,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertiserList()
    },
    confirm() {
      if (this.selectData.length === 0) {
        this.$message({
          message: '请选择广告账户',
          type: 'error'
        })
        return
      }
      console.log(11999, this.copyMpAdvertParams, this.selectData)

      const arr = []
      let project_ids = []

      for (let i = 0; i < this.selectData.length; i++) {
        arr.push({
          account_id: this.selectData[i].account_id,
          advertiser_name: this.selectData[i].advertiser_name,
          num: this.selectData[i].num,
          remark: this.selectData[i].remark,
          opt_status: this.selectData[i].operation,
          // pages_handle: this.selectData[i].pages_handle,
          begin_time: this.selectData[i].begin_time,
          end_time: this.selectData[i].end_time
        })
      }
      project_ids = this.type === 'batch' ? this.adgroup_items.map(e => e.project_id) : [this.rowData.project_id]
      // this.selectData.map(e => e.adgroup_id)
      const obj = {
        account_id: this.type === 'batch' ? this.adgroup_items[0].account_id : this.rowData.account_id,
        account_ids: arr,
        project_ids
      }
      console.log('adgroup_ids:', project_ids, arr, obj)

      this.$emit('qindian', obj, () => {
        this.copyMpAdvertParams.account_ids = null
        this.isVisibled = false
        this.currency = {
          cropNum: '',
          is_title: '0',
          is_notice: '0',
          is_repeat_submit: '0'
        }
      })
      this.isVisibled = false
    },
    judge(item, event) {
      const text = event.target.value
      console.log('event', event)
      if (Number(text) < 1) {
        text === '' ? (item.num = 1) : (item.num = Math.abs(text))
      } else if (Number(text) > 50) {
        text === '' ? (item.num = 1) : (item.num = 50)
      }
    },
    judges(item, event) {
      const text = event.target.value
      // if (Number(text) < 30) {
      //   item.jiange = 30
      // }
      if (Number(text) < 30 && Number(text) !== 0) {
        item.jiange = 30
      }
    },
    updateDatarw(item) {
      console.log('222')
    },
    handleCurrencyCropBegin_time() {
      if (!this.currency.begin_time) {
        return
      }
      this.selectData.forEach(item => {
        item.begin_time = this.currency.begin_time
      })
    },
    handleCurrencyCropEnd_time() {
      if (!this.currency.end_time) {
        return
      }
      this.selectData.forEach(item => {
        item.end_time = this.currency.end_time
      })
    },
    handleCurrencyCropNum() {
      if (!this.currency.cropNum) {
        return
      }
      this.selectData.forEach(item => {
        item.num = this.currency.cropNum
      })
    },
    handleParams(value) {
      console.log('value:', value)
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
      // this.mpAdvertiserListParams.name = value.replace(str, ',')
      const temp = value.replace(str, ',')
      const str1 = /(,){1,}/gim
      // this.mpAdvertiserListParams.name = this.mpAdvertiserListParams.name.replace(str1, ',')
      const temp1 = temp.replace(str1, ',')
      return temp1
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;
  .center-left {
    width: 70%;
  }
  .center-right {
    margin-left: 50px;
    // width: 500px;
    // max-height: 500px;
    overflow: auto;
    td {
      padding: 4px;
    }
  }

  .input {
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
::v-deep .center-container .center-left {
  width: 55%;
}
.fowwr {
  width: 50px;
}
</style>
